module.exports = __webpack_public_path__ + "img/caroussel_24.6f1b10c0.jpg";